import React from 'react';
import createReactClass from 'create-react-class';

import axios from '@/util/axios';
import { handleAxiosError } from 'core/notifications';
import i18n from 'i18next';
import mapValues from 'lodash/mapValues';
import { withContainer } from 'core/cache';

import getInitiativeWizardSchemas from '../schemas/getInitiativeWizardSchemas';
import getTopicTagMappingSchema from '../schemas/getTopicTagMappingSchema';

import InitiativeWizard from '../components/initiativeWizard';
import InitiativeWizardForm from '../components/initiativeWizardForm';
import InitiativeWizardSummary from '../components/initiativeWizardSummary';

const InitiativeWizardContainer = createReactClass({
  getInitialState() {
    return {
      errors: {},
      formState: {},
      index: 0,
      indexesViewed: new Set([0]),
      isSubmitting: false,
      model: {},
    };
  },

  handleDataErrors({ response }) {
    this.setState(({ errors }) => ({
      errors: {
        ...response.data?.errors?.reduce((a, { message, source }) => (
          { ...a, ...{ [source.split('data.').pop()]: message } }
        ), errors),
      },
    }));
  },

  handleEditButtonClick(index) {
    this.updateIndex(index);
    window.scrollTo(0, 0);
  },

  handleLoad({ formState }) {
    this.updateFormState(formState);
  },

  handleNavigateButtonClick(index) {
    this.updateIndex(index);
  },

  async handleSubmitButtonClick() {
    const { topics, ...initiative } = this.state.model;
    const data = { ...initiative, tagging_topic_ids: topics?.map(({ id }) => id) };

    this.setState({ isSubmitting: true });

    try {
      await axios.post('/api/admin/initiatives', { data });
    } catch (error) {
      this.setState({ isSubmitting: false });

      if (error.response?.status === 422) {
        return this.handleDataErrors(error);
      }

      return handleAxiosError(error);
    }

    this.props.history.push('/initiatives');
  },

  handleUpdate({ formState, update }) {
    this.updateFormState(formState);
    this.setState(({ model }) => ({ model: { ...model, ...update } }));
  },

  updateFormState(newState) {
    this.setState(({ errors, formState }) => ({
      errors: {
        ...errors,
        ...mapValues(newState, (({ error, hasError }) => hasError && error)),
      },
      formState: { ...formState, ...newState },
    }));
  },

  updateIndex(index) {
    this.setState(({ indexesViewed }) => ({
      index,
      indexesViewed: indexesViewed.add(index),
    }));
  },

  render() {
    const {
      errors,
      formState,
      index,
      indexesViewed,
      isSubmitting,
      model,
    } = this.state;

    const pages = [
      ...getInitiativeWizardSchemas().map(({ title, schema }, pageIndex) => ({
        title,
        body: (
          <InitiativeWizardForm
            model={model}
            onLoad={this.handleLoad}
            onUpdate={this.handleUpdate}
            schema={schema}
          />
        ),
        isComplete: indexesViewed.has(pageIndex) && Object.keys(schema).every((key) => (
          formState[key]?.hasError === false
        )),
      })),
      {
        title: i18n.t('summary'),
        body: (
          <>
            <InitiativeWizardSummary
              errors={errors}
              model={model}
              onEditButtonClick={this.handleEditButtonClick}
            />
            <InitiativeWizardForm
              model={model}
              onLoad={this.handleLoad}
              onUpdate={this.handleUpdate}
              schema={getTopicTagMappingSchema({ isWizard: true })}
            />
          </>
        ),
      },
    ];

    return (
      <InitiativeWizard
        currentIndex={index}
        isSubmitting={isSubmitting}
        onNavigateButtonClick={this.handleNavigateButtonClick}
        onSubmitButtonClick={this.handleSubmitButtonClick}
        pages={pages}
      />
    );
  },
});

export default withContainer(InitiativeWizardContainer, { hasRouter: true });
